// `LocaleService.getDisplayDateOnlyDateLocalized` (`locale.service.ng1.ts:31`) — the date
// format every ATS-sourced timestamp in the extension is shown in.

/**
 * ⚠️ NO LOCALE ARGUMENT, DELIBERATELY. `new Intl.DateTimeFormat()` follows the BROWSER's
 * locale, not the tenant's — so the same candidate reads 16/09/2026 in London and 9/16/2026 in
 * New York, and a baseline capture only matches production while both run the same locale.
 * Passing one here would be a redesign, not a port.
 *
 * ⚠️ AND IT RETURNS UNDEFINED, NOT '', for an absent date — every caller distinguishes the two:
 * the ATS card prints "Unknown" for undefined, and `getNoteSubtitle` decides whether to write a
 * " - " separator on whether this answered at all.
 */
export function displayDate(dateEpoch: number | null | undefined): string | undefined {
  // Upstream's guard is `!dateEpoch`, so epoch 0 is "no date" rather than 1 January 1970.
  if (dateEpoch === undefined || dateEpoch === null || dateEpoch === 0) return undefined
  return new Intl.DateTimeFormat().format(new Date(dateEpoch))
}
